import React from 'react';
import SmileEventCard from '../SmileEventCard';
import type { EventData } from '../../types/events';

const SMILE_EVENTS: EventData[] = [
  {
    id: 'smile-sat-26',
    venue: 'smile',
    venueName: 'Smile Matinée',
    title: '😃 SMILE MATINÉE',
    subtitle: 'SALAS - Presentación en vivo 🎤🔥',
    date: '2026-09-26',
    dateLabel: '26/09',
    dayLabel: 'Sábado',
    gradientClass: 'gradient-smile',
    accentColor: '#88ff00',
    borderColor: 'rgba(136, 255, 0, 0.6)',
    glowColor: 'rgba(136, 255, 0, 0.35)',
    timeRange: '19:00 a 23:59 hs ⏰',
    noListaFree: true,
    smileButtons: [
      { id: 'vip', label: 'Ingresos VIP', emoji: '⭐' },
      { id: 'general', label: 'General', emoji: '🎫' },
      { id: 'combos', label: 'Combos', emoji: '🍾' },
      { id: 'mesas', label: 'Mesas', emoji: '🪑' },
      { id: 'cumple', label: 'Cumpleaños', emoji: '🎂' },
    ],
  },
];

interface SmileMatineeTabProps {
  openListaFree?: (event: EventData) => void;
}

export default function SmileMatineeTab({ openListaFree: _openListaFree }: SmileMatineeTabProps) {
  return (
    <div className="animate-fade-in">
      {/* Neon Venue Header */}
      <div className="mb-6 text-center px-2">
        <h2
          className="text-5xl sm:text-6xl font-black tracking-tight uppercase leading-none"
          style={{
            color: '#fff',
            textShadow: '0 0 20px #fff, 0 0 50px rgba(255,255,255,0.6), 0 0 80px rgba(136,255,0,0.4)',
          }}
        >
          SMILE MATINÉE
        </h2>
        <p
          className="text-xl sm:text-2xl font-black tracking-[0.35em] uppercase mt-1"
          style={{
            color: '#38bdf8',
            textShadow: '0 0 14px #38bdf8, 0 0 30px rgba(56,189,248,0.7), 0 0 50px rgba(56,189,248,0.4)',
          }}
        >
          BUENOS AIRES
        </p>
        <div
          className="my-4 h-px w-full"
          style={{
            background: 'linear-gradient(90deg, transparent, #88ff00, #ffee00, #88ff00, transparent)',
            boxShadow: '0 0 10px rgba(136,255,0,0.8), 0 0 20px rgba(255,238,0,0.5)',
          }}
        />
        <p
          className="text-sm sm:text-base font-extrabold tracking-widest uppercase"
          style={{ color: '#88ff00', textShadow: '0 0 12px #88ff00, 0 0 24px rgba(136,255,0,0.6)' }}
        >
          LINE UP SEPTIEMBRE #2026
        </p>
        <p className="text-xs sm:text-sm text-muted-foreground mt-1 font-medium">
          PRÓXIMAS FECHAS – TOCÁ UNA PARA ANOTARTE O RESERVAR
        </p>
      </div>

      {/* Event List */}
      <div className="flex flex-col gap-3 max-w-2xl mx-auto">
        {SMILE_EVENTS.map((event) => (
          <SmileEventCard key={event.id} event={event} />
        ))}
      </div>
    </div>
  );
}